/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Cards_NavInputs */

const en_us2_wrapped_cards_nav = /** @type {(inputs: Wrapped_Cards_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cards`)
};

const pt_br2_wrapped_cards_nav = /** @type {(inputs: Wrapped_Cards_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartões`)
};

const es_419_wrapped_cards_nav = /** @type {(inputs: Wrapped_Cards_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjetas`)
};

const pt_pt2_wrapped_cards_nav = /** @type {(inputs: Wrapped_Cards_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartões`)
};

const fr_fr2_wrapped_cards_nav = /** @type {(inputs: Wrapped_Cards_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartes`)
};

const de_de2_wrapped_cards_nav = /** @type {(inputs: Wrapped_Cards_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karten`)
};

const it_it2_wrapped_cards_nav = /** @type {(inputs: Wrapped_Cards_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schede`)
};

/**
* | output |
* | --- |
* | "Cards" |
*
* @param {Wrapped_Cards_NavInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_cards_nav = /** @type {((inputs?: Wrapped_Cards_NavInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Cards_NavInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_cards_nav(inputs)
	if (locale === "es-419") return es_419_wrapped_cards_nav(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_cards_nav(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_cards_nav(inputs)
	if (locale === "de-DE") return de_de2_wrapped_cards_nav(inputs)
	if (locale === "it-IT") return it_it2_wrapped_cards_nav(inputs)
	return en_us2_wrapped_cards_nav(inputs)
});
export { wrapped_cards_nav as "wrapped.cards_nav" }